import { status } from 'src/colors';
import { SpaceState } from '../../types/space-state';

export const spaceStateColors: Record<SpaceState, string> = {
  AVAILABLE: status.success,
  BLOCKED: status.error,
  BOOKED: status.info,
} as const;
